"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icons_1 = require("../../../Icons");
var Localization_1 = require("../../../Localization");
var CameraPhoto_styles_1 = require("./CameraPhoto.styles");
exports.default = (function (_a) {
    var OnTakePhoto = _a.OnTakePhoto, EncoderImageType = _a.EncoderImageType, EncoderOptions = _a.EncoderOptions;
    var videoRef = React.createRef();
    var buttonRef = React.createRef();
    var _b = React.useState(true), hasCamera = _b[0], setHasCamera = _b[1];
    var handleTakePhotoClick = function () {
        var draw = document.createElement("canvas");
        var video = videoRef.current;
        draw.width = video.videoWidth;
        draw.height = video.videoHeight;
        var context2D = draw.getContext("2d");
        context2D.drawImage(video, 0, 0, draw.width, draw.height);
        OnTakePhoto(draw.toDataURL(EncoderImageType, EncoderOptions), undefined);
    };
    React.useEffect(function () {
        if (navigator && navigator.mediaDevices) {
            navigator.mediaDevices.getUserMedia({ video: true })
                .then(function (stream) {
                setHasCamera(true);
                videoRef.current.srcObject = stream;
                videoRef.current.play();
                buttonRef.current.focus();
            })
                .catch(function () {
                setHasCamera(false);
            });
        }
        else {
            setHasCamera(false);
        }
        return function () {
            if (videoRef && videoRef.current) {
                videoRef.current.srcObject.getTracks().forEach(function (stream) {
                    stream.stop();
                });
                videoRef.current.pause();
            }
        };
    }, [videoRef]);
    return React.createElement(React.Fragment, null, hasCamera
        ?
            React.createElement(CameraPhoto_styles_1.VideoWrapper, null,
                React.createElement(CameraPhoto_styles_1.Video, { ref: videoRef }),
                React.createElement(CameraPhoto_styles_1.TakePhoto, { "aria-label": Localization_1.strings.UploadAvatar_Action_TakePhoto, onClick: handleTakePhotoClick, ref: buttonRef, title: Localization_1.strings.UploadAvatar_Label_TakePhoto },
                    React.createElement(Icons_1.CameraIcon, null)))
        :
            React.createElement(CameraPhoto_styles_1.NoVideo, null, Localization_1.strings.UploadAvatar_Message_NoCamera));
});
